import { KoncentroBaseModel } from './koncentro-base.model';

export class FrontEnd extends KoncentroBaseModel {
  public dto = 'FrontEndDto';

  public id?: number;
  public code: string;
  public name: string;
  public description: string;
  public img_b64: string;
  public img_url: string;
  public flg_state: number;
}



// WEBPACK FOOTER //
// ./src/app/models/front-end.model.ts